import { join } from 'path';
import { Location } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation, Renderer2 } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MoviesService } from '../core/services/movies.service';
import Swal from 'sweetalert2';
import videojs from 'video.js';
import { MovieLinkInfoTCC2, Subtitle } from '../core/interfaces/movieLink2.model';
require('@silvermine/videojs-chromecast')(videojs, { preloadWebComponents: true });
import '@silvermine/videojs-chromecast/dist/silvermine-videojs-chromecast.css';
import { AuthService } from '../core/auth/auth.service';
import { event } from 'jquery';
import 'videojs-contrib-dash';

declare const chrome: any;
declare const cast: any;

@Component({
  selector: 'app-watch',
  templateUrl: './watch.component.html',
  styleUrls: ['./watch.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WatchComponent implements OnInit, OnDestroy {
  @ViewChild('target', { static: true }) target: ElementRef;
  url: string;
  keys: string;
  subtitle: Subtitle;
  linkInfo: MovieLinkInfoTCC2;
  verControles = false;
  private player: videojs.Player;
  loading: boolean;
  intervalId: any;
  ipValid = true;
  options: any = {
    fluid: true,
    muted: false,
    // aspectRatio: string,
    controls: true,
    autoplay: true,
    techOrder: ['chromecast', 'html5'],
    loop: true,
    fill: true,
    html5: {
      nativeTextTracks: false,
      nativeCaptions: false
    },
    chromecast: {
      requestCustomDataFn: function (source) { // Not required
        return { ...source.keySystemOptions[0].options, ...source.srcLang };
      },
    },
    plugins: {
      chromecast: {
        buttonPositionIndex: -2,
        receiverAppID: '7D4CA9D4'  //Receiver Prod
        // receiverAppID: '73D71B64'  //Receiver Test
      }
    }
  }

  constructor(
    private moviesService: MoviesService,
    private sanitizer: DomSanitizer,
    private actRoute: ActivatedRoute,
    private location: Location,
    private elementRef: ElementRef,
    private ElByClassName: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.initPlayer();
  }

  async initPlayer() {
    this.loading = true;

    let parameters;
    this.actRoute.params.subscribe((params) => {
      parameters = params
    });

    if (this.auth.estaAutenticado()) {
      this.ipValid = await this.auth.ipValid(parameters.id);
      if (this.ipValid) {
        await this.moviesService.getMovieLinkInfoTCC(parameters.id).then(
          (res) => {
            if (res.accesible) {
              this.linkInfo = res;
              this.url = this.linkInfo.dash.replace("http:", "https:");
              this.keys = this.linkInfo.drm.widevine.license_url;

              this.player = videojs(this.target.nativeElement, this.options);
              this.player.src({
                src: this.url,
                type: "application/dash+xml",
                keySystemOptions: [
                  {
                    name: "com.widevine.alpha",
                    options: {
                      serverURL: this.keys,
                      "com.widevine.alpha": this.keys,
                    }
                  }
                ],
              } as any);

              this.player.addClass('videoParent');                                //Para estilizar el parent.
              this.player.getChild('textTrackSettings').addClass("captionStyle"); //Para estilizar el menu de subtitulos.
              this.player.load();
              this.player.play();
              this.loading = false;
            }
            else {
              Swal.fire('Ups!', 'No tienes acceso a este contenido', 'error').then(() => {
                this.router.navigateByUrl('/movie/' + parameters.id)
                this.loading = false;
              });
            }
          });

      }
    }
  }


  back() {
    window.history.go(-1);
  }

  controles_alternar() {
    this.verControles = !this.verControles;
    let timer = setTimeout(() => {
      this.verControles = false;
    }, 2000);
    if (!this.verControles) clearTimeout(timer);
  }

  loadInterval() {
    const btnElement = (<HTMLElement>this.ElByClassName.nativeElement).querySelector(
      '.vjs-chromecast-button'
    );
    if (btnElement) {
      this.renderer.removeClass(btnElement, "vjs-hidden");
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    } else {
      this.intervalId = setInterval(() => {
        this.loadInterval();
      }, 1000);
    }
  }

  ngOnDestroy() {
    // destroy player
    if (this.player) {
      this.player.dispose();
    }
  }

}
